module.exports = __webpack_public_path__ + "static/media/banco_de_questoes.c7635d97.svg";